import template from './coworking-workplace-banner.jade';
import { CoworkingWorkplaceBanner } from './coworking-workplace-banner.controller';
import './coworking-workplace-banner.css';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {},
    controller: CoworkingWorkplaceBanner,
    controllerAs: 'coworkingWorkplaceBannerCtrl',
    replace: true,
  };
};
